module.exports = __webpack_public_path__ + "app/components/id-do-select-tag-2BtWvDlD.html";